import { type ReactNode } from 'react';
import { LandingPageLayoutSwitcher } from 'src/features/homeowners/components/landing-page-layout-switcher/landing-page-layout-switcher';
import { LandingPageSwitcher } from 'src/features/homeowners/components/landing-page-switcher/landing-page-switcher';
import {
  type ServerProps,
  getLandingPageGetStaticProps,
} from 'src/features/homeowners/components/landing-page/landing-page';

export default function HomeownersLandingPage({
  blogPosts,
  homeownersCount,
  coverageCities,
  heroCopyVariant,
}: ServerProps) {
  return (
    <LandingPageSwitcher
      blogPosts={blogPosts}
      homeownersCount={homeownersCount}
      coverageCities={coverageCities}
      heroCopyVariant={heroCopyVariant}
    />
  );
}

HomeownersLandingPage.getLayout = function getLayout(
  page: ReactNode,
): ReactNode {
  return <LandingPageLayoutSwitcher page={page} />;
};

export const getServerSideProps = getLandingPageGetStaticProps();
